import { cn } from "@/lib/utils";
import { AlertTriangle, Loader2, PackageOpen } from "lucide-react";
import type { ReactNode } from "react";
import { Button } from "../ui/button";

export const LoadingState = ({ label = "Loading…" }: { label?: string }) => (
  <div className="flex items-center justify-center gap-2 py-12 text-sm text-muted-foreground">
    <Loader2 className="size-4 animate-spin" aria-hidden />
    {label}
  </div>
);

export const EmptyState = ({
  title,
  description,
  action,
  icon,
  className,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
  className?: string;
}) => (
  <div
    className={cn(
      "flex flex-col items-center justify-center gap-3 rounded-card border border-dashed border-border px-6 py-12 text-center",
      className,
    )}
  >
    <div className="text-muted-foreground">{icon ?? <PackageOpen className="size-8" aria-hidden />}</div>
    <div className="space-y-1">
      <p className="font-medium">{title}</p>
      {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
    </div>
    {action}
  </div>
);

export const ErrorState = ({
  title = "Something went wrong",
  description,
  onRetry,
}: {
  title?: string;
  description?: string;
  onRetry?: () => void;
}) => (
  <div className="flex flex-col items-center gap-3 rounded-card border border-danger/40 bg-danger/5 px-6 py-10 text-center">
    <AlertTriangle className="size-7 text-danger" aria-hidden />
    <div className="space-y-1">
      <p className="font-medium">{title}</p>
      {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
    </div>
    {onRetry ? (
      <Button variant="outline" size="sm" onClick={onRetry}>
        Try again
      </Button>
    ) : null}
  </div>
);
